import React from 'react';

import './index.css';

const Content = (props) => <div {...props} className="content" />

export default Content;
